/** The readable session cookie words-happen-gql sets beside the HttpOnly token: present means signed in. */
export const AUTH_COOKIE = 'auth';

/** Reads and deletes the `auth` cookie. Injectable so it can be tested. */
export interface AuthCookie {
  present: () => boolean;
  /** Deletes it on the parent domain it was set on. */
  remove: () => void;
}

/** Whether a `document.cookie` string holds a non-empty auth cookie. */
export const hasAuthCookie = (cookies: string): boolean =>
  cookies.split(';').some((cookie) => {
    const [name, ...value] = cookie.trim().split('=');
    return name === AUTH_COOKIE && value.join('=') !== '';
  });

/** The Set-Cookie-style string that deletes the auth cookie on `domain`, matching the attributes it was set with. */
export const deletedAuthCookie = (domain: string): string =>
  `${AUTH_COOKIE}=; Max-Age=0; Domain=${domain}; Path=/; Secure; SameSite=Lax`;

export const documentAuthCookie = (domain: string = SESSION_COOKIE_DOMAIN, doc: Document = document): AuthCookie => ({
  present: () => hasAuthCookie(doc.cookie),
  remove: () => {
    doc.cookie = deletedAuthCookie(domain);
  },
});
